<template>
    <section class="main" :style="{'background-color': block.color, 'padding-top': block.paddingTop + 'px', 'padding-bottom': block.paddingBottom + 'px'}">
        <div style="position: absolute; top: 16px; right: 16px;z-index: 2" class="hovered">
            <v-btn icon @click="sheet = true">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-btn icon @click="incrementCols">
                <v-icon>mdi-table-column-plus-after</v-icon>
            </v-btn>
            <v-btn icon @click="decrementCols">
                <v-icon>mdi-table-column-remove</v-icon>
            </v-btn>
            <v-btn icon @click="$emit('move_row_up')">
                <v-icon>mdi-arrow-up</v-icon>
            </v-btn>
            <v-btn icon @click="$emit('move_row_down')">
                <v-icon>mdi-arrow-down</v-icon>
            </v-btn>
            <!--<v-btn icon @click="$emit('copy_main_block')">-->
                <!--<v-icon>mdi-content-copy</v-icon>-->
            <!--</v-btn>-->
            <!--<v-btn icon @click="settings = true">-->
                <!--<v-icon>mdi-cog</v-icon>-->
            <!--</v-btn>-->
            <!--<v-btn icon @click="$emit('block-delete')">-->
                <!--<v-icon>mdi-delete</v-icon>-->
            <!--</v-btn>-->
            <v-menu top left>
            <template v-slot:activator="{ on }">
            <v-btn class="link-context-menu" v-on="on" icon  >
                <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>

            </template>
            <v-list>

                <v-list-item @click="$emit('copy_main_block')">
                    <v-list-item-title>Копировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="settings = true">
                    <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('block-delete')">
                    <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
            </v-list>
            </v-menu>

        </div>

        <v-container style="position: relative; max-width: 1200px; margin: 0 auto">
            <v-row >
                <v-col :cols="cols" v-for="(item, index) in block.items" :key="item.id" style="position: relative">
                    <LinksBlockLink v-if="item.type == 'link'" :link="item.link" @move_block_right="move_block_right(index)" @move_block_left="move_block_left(index)" @copy_block="copy(index)"  @update-link="item.link = $event" @delete-link="delItem(index)"></LinksBlockLink>
                    <text-item v-if="item.type == 'text'" :item="item" @move_block_right="move_block_right(index)" @move_block_left="move_block_left(index)" @copy_block="copy(index)" @delete-link="delItem(index)"></text-item>
                    <reportblock v-if="item.type == 'report'" :item="item" @move_block_right="move_block_right(index)" @move_block_left="move_block_left(index)" @copy_block="copy(index)" @delete-link="delItem(index)"></reportblock>
                </v-col>
                <v-col :cols="cols" style="position: relative; min-height: 200px;" v-if="showAdder">
                    <div class="item-add-btn" @click="sheet = true">
                        <v-icon size="70">mdi-plus</v-icon>
                    </div>
                </v-col>
            </v-row>
        </v-container>


        <v-dialog v-model="adder" max-width="600px">
            <link-adder @close-adder="adder = false" @create-link="addLinkItem($event)"></link-adder>
        </v-dialog>

        <v-dialog
                v-model="settings"
                max-width="600px"
                scrollable
        >
            <items-block-settings v-model="block" @close-settings="settings = false"></items-block-settings>
        </v-dialog>


        <v-bottom-sheet v-model="sheet" inset>
            <v-sheet class="text-center" height="200px">
                <v-container style="height: 100%">
                    <v-row style="height: 100%">
                        <v-col cols="3" style="height: 100%">
                            <div class="item-select-btn" @click="addTextItem(), sheet = false">
                                <v-icon size="50">mdi-text</v-icon>
                                <span style="font-size: 20px">Текст</span>
                            </div>
                        </v-col>
                        <v-col cols="3" style="height: 100%">
                            <div class="item-select-btn" @click="adder = true, sheet = false">
                                <v-icon size="50">mdi-link</v-icon>
                                <span style="font-size: 20px">Ссылка</span>
                            </div>
                        </v-col>
                        <v-col cols="3" style="height: 100%">
                            <div class="item-select-btn" @click="addReportItem(), sheet = false">
                                <v-icon size="50">mdi-note-text-outline</v-icon>
                                <span style="font-size: 20px">Отчёт</span>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-sheet>
        </v-bottom-sheet>


    </section>
</template>

<script>
    import LinksBlockLink from "./LinksBlockLink";
    import TextItem from "./Items/TextItem";
    import LinkAdder from "./LinksBlockLinkAdder";
    import ItemsBlockSettings from "./ItemsBlockSettings";
    import reportblock from "./reportblock"

    export default {
        name: "ItemsBlock",
        props:["block"],
        components:{
            LinksBlockLink,
            TextItem,
            LinkAdder,
            ItemsBlockSettings,
            reportblock
        },
        data(){
            return{
                sheet: false,
                adder: false,
                render: true,
                settings: false
            }
        },
        computed:{
            showAdder(){
                if(this.block.items.length < this.block.cols){
                    return true;
                } else if (this.block.items.length % this.block.cols != 0){
                    return true;
                }
                return false

            },
            cols () {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return 12
                    case 'sm': return 12
                    case 'md':
                        switch(this.block.cols){
                            case 1: return 12
                            case 2: return 6
                            case 3: return 4
                            case 4: return 3
                        }
                        break
                    case 'lg':
                        switch(this.block.cols){
                            case 1: return 12
                            case 2: return 6
                            case 3: return 4
                            case 4: return 3
                        }
                        break
                    case 'xl':
                        switch(this.block.cols){
                            case 1: return 12
                            case 2: return 6
                            case 3: return 4
                            case 4: return 3
                        }
                        break
                }
                return false
            },
            maxId(){
                if(this.block.items.length == 0){
                    return 0;
                } else {
                    return Math.max(...this.block.items.map(kek => kek.id))
                }
            }
        },
        methods:{

            addReportItem(){
                this.block.items.push(
                    {
                        id: this.maxId + 1,
                        type: "report",
                        title: "Заголовок",
                        text: "Смотреть →",
                        urllink:'',
                    }
                )
            },
            addTextItem(){
                this.block.items.push(
                    {
                        id: this.maxId + 1,
                        type: "text",
                        content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                        align: "center"
                    }
                )
            },
            addLinkItem(link){
                this.block.items.push({
                    id: this.maxId + 1,
                    type: "link",
                    link: link
                })
            },
            incrementCols(){
                if(this.block.cols == 4){
                    return false
                } else {
                    this.block.cols++
                }
            },
            decrementCols(){
                if(this.block.cols == 1){
                    return false
                } else {
                    this.block.cols--
                }
            },
            move_block_left(index)
            {
                if(index === 0){return}
                let rows = [ this.block.items[index-1],  this.block.items[index]];
                this.block.items.splice(index-1, 2, rows[1], rows[0] );
            },
            move_block_right(index)
            {
                if(index === this.block.items.length-1){return}
                let rows = [ this.block.items[index],  this.block.items[index+1]];
                this.block.items.splice(index, 2, rows[1], rows[0] );

            },
            copy(index){
               let copy = Object.assign({},  this.block.items[index])
                copy.id=this.maxId + 1;
                this.block.items.push(copy);

            },
            delItem(indexx){
                this.block.items.splice(indexx, 1);
                //this.forceRerender()
            },
            forceRerender() {
                // Remove component from the DOM
                this.render = false;
                this.$nextTick(() => {
                    // Add the component back in
                    this.render = true;
                });
            }
        }
    }
</script>

<style scoped>

    .main{
        position: relative;
    }

    .item-add-btn{
        width: 100%;
        height: 100%;
        border: 5px dashed rgba(0,0,0,.54);
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        transition: 0.3s;
        cursor: pointer;
    }

    .main:hover .item-add-btn{
        opacity: 0.5;
    }

    .item-select-btn{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        cursor: pointer;
    }

    .hovered{
        opacity: 0;
        transition: 0.3s;
    }

    .main:hover .hovered{
        opacity: 1;
    }




</style>